import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Fab, Tooltip } from '@mui/material';
import { Facebook, LinkedIn, Mail, Phone, QrCodeScanner } from '@mui/icons-material';
import { t } from 'i18next';
import ConatctQr from "../Files/ContactQr.png"

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ContactQr() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Tooltip title="Mon contact">
        <Fab className='ibg-fab ibg-fab--dark' onClick={handleClickOpen} style={{ position: 'fixed', bottom: 24, right: 24 }}>
          <QrCodeScanner />
        </Fab>
      </Tooltip>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{ sx: { borderRadius: '24px' } }}
      >
        <DialogContent className='boxQrContact ibg-qr'>
          <div className='ibg-qr__list'>
            <h2>{t("contact")}</h2>
            <a href="tel:+237690767963"><span><Phone /></span>(+237) 690 767 963</a>
            <a href="mailto:contact@ibgalphatech.com"><span><Mail /></span>contact@ibgalphatech.com</a>
            <div><span><Facebook /></span>@ibgalphatech</div>
            <div><span><LinkedIn /></span>@ibgalphatech</div>
          </div>
          <div className='ibg-qr__code'>
            <img src={ConatctQr} alt="QR code" />
            <p>{t("contact-sous-titre")}</p>
            {/* <br />
            <Button onClick={() => { window.open(env.DOWNLOAD_CONTACT_LINK) }} startIcon={<Download />} >{t("telecharger")}</Button> */}
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}